import React, { useState } from "react";
import { checkAdminRights } from "../../../Library/helper";
import translate from "../../Translations/index";
import { operatorVar } from "../../../Library/Cache/operatorCache";
import { useRouteMatch } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { visitorListVar } from "../../../Library/Cache/visitorListCache";
import SearchInput from "../../../GlobalComponents/SearchInput";
import Dropdown from "../../../GlobalComponents/Dropdown";

const Tasks = (props) => {
    let { path, url } = useRouteMatch();
    const operatorData = operatorVar();
    checkAdminRights(operatorData, ["1", "2", "3"], props);

    const allVisitors = useReactiveVar(visitorListVar);

    const [selectedPage, setSelectedPage] = useState(0);
    const [filters, setFilters] = useState({
        searchQuery: "",
        orderBy: "id",
        operatorID: "",
        offset: 0,
        limit: 10,
    });
    return (
        <div className="tasks-page">
            <div className="page">
                <div className="tasks-title">
                    <h1>{translate.t("Tasks")}</h1>
                    <div className="count">{allVisitors?.length}</div>
                </div>
                <div className="controls list-header">
                    <div className="form-group search">
                        <label>{translate.t("SearchVisitor")}</label>
                        <div className="input-group has-addon-left has-addon-right search-input">
                            <span className="addon left">
                                <i className="las la-search icon"></i>
                            </span>
                            <SearchInput
                                value={filters.searchQuery}
                                onChange={(text) => {
                                    setFilters({ ...filters, searchQuery: text });
                                    setSelectedPage(0);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group filter ml-auto">
                        <label>{translate.t("FilterTitle")}</label>
                        <Dropdown
                            className="filled"
                            content={
                                <>
                                    <i className="las la-filter icon"></i>
                                    {filters.operatorID == "" && translate.t("ShowAll")}
                                    {filters.operatorID == operatorData.operatorID && translate.t("ShowMy")}
                                </>
                            }
                            arrowLeft="auto"
                            arrowRight="1.1rem"
                            contentWidth="21rem"
                            showDropdown={true}
                            dropdownContent={
                                <>
                                    <div
                                        className="dropdown-item"
                                        onClick={(e) => {
                                            setFilters({ ...filters, operatorID: "" });
                                            setSelectedPage(0);
                                        }}
                                    >
                                        <div className="text">{translate.t("ShowAll")}</div>
                                    </div>
                                    <div
                                        className="dropdown-item"
                                        onClick={(e) => {
                                            setFilters({ ...filters, operatorID: operatorData.operatorID });
                                            setSelectedPage(0);
                                        }}
                                    >
                                        <div className="text">{translate.t("ShowMy")}</div>
                                    </div>
                                </>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tasks;
